// ./stores/memos.js
import {create} from 'zustand'

export interface Opinion {
    createdAt: string
    diagnosis: string
    doctorOpinion: string
    estiID: number
    id: number
    memo: string | null
    opinionURL: string | null
    receiver: string | null
    state: string
    writer: string
    petName: string
    petAge: number
    petGender: number
    petKind: string
    petWeight: number
    guardianName: string
}

interface OpinionState {
    opinionList: Opinion[],
    setOpinionList: (opinionList: Opinion[]) => void,
    curOpinion: Opinion | null,
    setCurOpinion: (opinion: Opinion|null) => void
}

const useOpinionStore = create<OpinionState>((set) => ({
    opinionList: [],
    setOpinionList: (opinionList: Opinion[]) => set({ opinionList : opinionList }),
    curOpinion: null,
    setCurOpinion: (opinion: Opinion|null) => set({ curOpinion: opinion })
}))


export default useOpinionStore